import React, { useCallback, useRef, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { adminActualityLink } from '../../constants/endspoints'

import { useQuery, useMutation, useQueryClient, useInfiniteQuery } from '@tanstack/react-query';
import { createCategory, fetchCategories, updateCategory } from '../../api/categories';
import IsEmpty from '../../components/IsEmpty';
import { useForm } from 'react-hook-form';
import Modal from 'react-responsive-modal';
import { fetchMedias } from '../../api/media';
import { toast } from 'react-toastify';

const ActualitiesCategory = () => {

    const {register,formState: { errors },handleSubmit} = useForm();

    const [showInput, setShowInput] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [idUpdate, setIdUpdate] = useState(null)




    const queryClient = useQueryClient();
    const [formData, setFormData] = useState({ name:'', picture:'' });

    // Fetch All Medias
    const { 
        data: dataImage, 
        fetchNextPage, 
        hasNextPage, 
        isFetchingNextPage, 
        status,
    } = useInfiniteQuery({
        queryKey: ["medias"],
        queryFn: fetchMedias,
        getNextPageParam: (lastPage) => lastPage.nextPage,
    });



    const observer = useRef();
    const lastMediaRef = useCallback((node) => {
        if (isFetchingNextPage) return;
        if (!hasNextPage) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                fetchNextPage(); 
            }
        });

        if (node) observer.current.observe(node);
    }, [isFetchingNextPage, hasNextPage, fetchNextPage]);







    // Fetch all categories
    const { data: categoriesData, isLoading: isFetchingData } = useQuery({
        queryKey: ['categories'],
        queryFn: fetchCategories,
    });



    // Create category
    const toastId = useRef(null);
    const addCategory = useMutation({
        mutationFn: (data)=> createCategory(data),
        onMutate: ()=>{
            toastId.current = toast.loading("Création en cours...", { 
                position: 'top-right',
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['categories']);
            toast.dismiss(toastId.current)
            toastId.current = toast.success("Catégorie ajoutée avec succès", {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            setFormData({ name:'', picture:'' })
            setShowInput(false)
        },
        onError: (err) =>{
            toast.dismiss(toastId.current)
            toastId.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true,
            });
        }
    });


    // Update category
    const toastIdUpdate = useRef(null);
    const updateMutation = useMutation({
        mutationFn: ( data ) => {updateCategory(data.id, data.data); console.log(data.id, data.data)}, 
        onMutate: ()=>{
            toastIdUpdate.current = toast.loading("Modification en cours...", { 
                position: 'top-right',
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['categories']);
            toast.dismiss(toastIdUpdate.current)
            toastIdUpdate.current = toast.success("Catégorie mise à jour avec succès", {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            setFormData({ name: '', picture: '' });
            setIdUpdate(null);
        },
        onError: (err) => {
            toast.dismiss(toastIdUpdate.current)
            toastIdUpdate.current = toast.error("Erreur lors de la modification: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true,
            });
        },
    });    


    return (
        <div>
            <h1 className='fs-3 fw-bold mb-3'> <NavLink className={'fs-3 fw-bold text-white'} to={adminActualityLink}>Actualités</NavLink> / Catégories</h1>

            <div className='bg-black rounded-3 p-2 shadow'>
                <h2 className='fs-5 fw-bold mb-2'>Liste des catégories</h2>

                <div className='d-flex justify-content-between align-items-center'>
                    <div role='button' onClick={()=>setShowInput(true)} className='d-flex align-items-center px-2 py-1 bgcolor-primary rounded-3'>
                        <i className="fa-light fa-square-plus me-2 text-white"></i>
                        <span className=' fs-9s text-white'>Ajouter une catégorie</span>
                    </div>
                </div>

                <div className={`mt-3 d-flex flex-column align-items-center ${!showInput ? 'd-none' : ''}`}>
                    <div role='button' className='inputFile mb-2' onClick={()=>setOpenModal(true)} >
                        {
                            !formData.picture?
                            <label className='d-flex flex-column justify-content-center align-items-center h-100 p-2'>
                                <i className="fa-light fa-images fs-3 opacity-75"></i>
                                <span className='text-center fw-medium'>Cliquer pour choisir des images ( Entre 0 - 1Mo )</span>
                            </label>
                            :
                            <img
                                src={formData.picture}
                                alt={formData.name}
                                className='img-fluid object-fit-contain m-1 border bordercolor-primary'
                                style={{ height: "5rem", width: "auto" }}
                            />
                        }
                    </div>
                    <input type='text' {...register("label", {required: true })} onChange={(e)=>setFormData({ ...formData, name: e.target.value })} value={formData.name} placeholder='Nom de la catégorie' className='form-control shadow-none bg-black fs-9s text-white py-1'/>
                    <button 
                        onClick={()=>handleSubmit(addCategory.mutate(formData))}
                        className='btn bgcolor-primary text-white fs-9s py-1 px-2 mt-2 submit' 
                        disabled={addCategory.isPending}
                    >
                        {addCategory.isPending ? 'Patientez...' : 'Ajouter'}
                    </button>
                </div>
                {errors.label && <small className="text-danger fs-7s" role="alert">Libellé requis</small>}

                {/* Liste */}
                <div className='mt-3 table-responsive'>
                    <table className='table table-dark table-striped table-hover table-sm fs-9s align-middle'>
                        <thead>
                            <tr>
                                <th className='fs-9s'>#</th>
                                <th className='fs-9s'>Image</th>
                                <th className='fs-9s'>Libellé</th>
                                <th className='fs-9s'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                isFetchingData?
                                [1,2,3,4,5].map((item, index) => (
                                    <tr key={index}>
                                        <td className='fs-9s fw-bold placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                        <td className='fs-9s placeholder-wave'><div style={{width:"3rem", height:"2rem"}} className='placeholder col-12 bgcolor-primary rounded'></div></td>
                                        <td className='fs-9s placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                        <td className='fs-9s placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    </tr>
                                ))
                                :
                                categoriesData?.data?.length !== 0 ?
                                    categoriesData?.data?.map((category, index) => (
                                        <tr key={category?.id}>
                                            <td className='fs-9s fw-bold'>{index+1}</td>
                                            {
                                                idUpdate === category?.id ?
                                                <>
                                                    <td className='fs-9s'>
                                                        <img 
                                                            alt={"*"} 
                                                            src={formData.picture} 
                                                            role='button'
                                                            onClick={()=>setOpenModal(true)} 
                                                            className='object-fit-cover rounded border border-2 bordercolor-primary' 
                                                            style={{width:"3rem", height: "2rem"}} 
                                                        />
                                                    </td>
                                                    <td className='fs-9s'>
                                                        <input type='text' {...register("labelUp"+category.id, {required: true })} onChange={(e)=>setFormData({ ...formData, name: e.target.value })} value={formData.name} placeholder='Nom de la catégorie' className='form-control shadow-none bg-black fs-9s text-white py-1'/>
                                                    </td>
                                                    <td className='fs-9s'>
                                                        <div className='text-white d-flex flex-nowrap'>
                                                            <button disabled={updateMutation.isPending} title='Annuler' onClick={()=>{setFormData({name:"", picture: ""});setIdUpdate(null)}} className='fa-light fa-xmark px-2 py-1 bg-danger fs-9s rounded border-0 text-white me-2'></button>
                                                            <button disabled={updateMutation.isPending} title='Modifier' onClick={()=>updateMutation.mutate({id: category.id, data: formData})} className='fa-light fa-check px-2 py-1 bg-success fs-9s rounded border-0 text-white '></button>
                                                        </div>
                                                    </td>
                                                </>:
                                                <>
                                                    <td className='fs-9s'>
                                                        <img 
                                                            alt={"*"} 
                                                            src={category.picture} 
                                                            className='object-fit-cover rounded' 
                                                            style={{width:"3rem", height: "2rem"}} 
                                                        />
                                                    </td>
                                                    <td className='fs-9s'>{category.name}</td>
                                                    <td className='fs-9s'>
                                                        <button 
                                                        className='border-0 bg-transparent' 
                                                        disabled={updateMutation.isPending} 
                                                        onClick={()=>{
                                                            setIdUpdate(category.id);
                                                            setFormData({ name: category.name, picture: category.picture });
                                                            }
                                                        }>
                                                            <i className='fa-light fa-pen-to-square fs-9s text-white'></i>
                                                        </button>
                                                    </td>
                                                </>
                                            }
                                        </tr>
                                    ))
                                    :
                                    <tr>
                                        <td  colspan="3" className='w-100'>
                                            <IsEmpty icon={"fa-light fa-list"} message={"Aucune catégorie enregistrée"} />
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>


            </div>



            {/* Image selector */}
            <Modal open={openModal} onClose={()=>setOpenModal(false)} center classNames={{modal: 'rounded-3 shadow-lg bg-black border',}} closeIcon={<i className="fa fa-times text-white"></i>}>
                <div className='bg-black p-2 rounded-3 shadow d-flex justify-content-start flex-wrap g-1 mt-4 overflow-y-scroll' style={{maxHeight:"70vh"}}>
                    
                {status === "pending" ? (
                        <div className=' d-flex justify-content-center align-items-center h-100 w-100'>
                            <p className='text-white'>Chargement des médias...</p>
                        </div>
                    ) : status === "error" ? (
                        <div className=' d-flex justify-content-center align-items-center h-100 w-100'>
                            <p className='text-white'>Une erreur est survenue.</p>
                        </div>
                    )
                    :dataImage?.pages?.flatMap((page, pageIndex) => 
                        page?.data?.map((media, index) => {
                            const isLastItem = pageIndex === dataImage?.pages?.length - 1 && index === page?.data?.length - 1;
                            return (
                                <img
                                    key={media.id}
                                    ref={isLastItem ? lastMediaRef : null}
                                    src={media.filePath}
                                    alt=''
                                    className='img-fluid object-fit-contain m-1 border bordercolor-primary'
                                    style={{ height: "5rem", width: "auto" }}
                                    onClick={()=>{setFormData({ ...formData, picture: media.filePath }); setOpenModal(false)}}
                                />
                            )
                        })
                    )
                }
                {isFetchingNextPage && <div className=' d-flex justify-content-center align-items-center h-100 w-100'><p className="fs-9s">Chargement...</p></div>}
                {(dataImage?.pages?.length < 0) && <IsEmpty icon={'fa-light fa-image'} message={'Aucune image'} />}
                </div>
            </Modal>




        </div>
    )
}

export default ActualitiesCategory